/* 🤖 this file was generated by svg-to-ts */
export const matIconRemoveDone: {
  name: 'remove-done';
  data: string;
} = {
  name: 'remove-done',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M4.84 1.98 3.43 3.39l10.38 10.38-1.41 1.41-4.24-4.24-1.41 1.41 5.66 5.66 2.83-2.83 6.6 6.6 1.41-1.41L4.84 1.98zm13.21 10.38L23 7.4 21.57 6l-4.94 4.94 1.42 1.42zm-.71-4.96-1.41-1.41-2.12 2.12 1.41 1.41 2.12-2.12zM1.08 12.35l5.66 5.66 1.41-1.41-5.66-5.66-1.41 1.41z"/></svg>`
};
